import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { isNil } from 'lodash';

import { ScrollToButton } from '../../components/button';

import styles from './exploration.module.scss';
import { headerHeight } from '../../components/header/header.module.scss';

const HEADER_HEIGHT = parseInt(headerHeight, 10);

export const ScrollToSelected = ({
  cellId,
  direction,
  onClick,
}: {
  cellId?: string | undefined;
  direction?: 'up' | 'down';
  onClick: () => void;
}) => {
  const [cellDirection, setCellDirection] = useState<'up' | 'down' | null>(null);

  useEffect(() => {
    const onScroll = () => {
      const element = document.querySelector(`[data-id="${cellId}"]`);
      if (isNil(element)) {
        return null;
      }
      const { top, bottom } = element.getBoundingClientRect();
      if (bottom < HEADER_HEIGHT) {
        setCellDirection('up');
      } else if (top > window.innerHeight) {
        setCellDirection('down');
      } else {
        setCellDirection(null);
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, true);
    return () => window.removeEventListener('scroll', onScroll);
  });

  if (cellId === undefined) {
    return null;
  }

  return (
    <aside
      className={classNames(styles.scrollToSelected, {
        [styles.visible]:
          cellDirection !== null && (direction === undefined || direction === cellDirection),
      })}>
      <ScrollToButton label="Selected block" direction={cellDirection ?? 'up'} onClick={onClick} />
    </aside>
  );
};
